var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPython = function SvgPython(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#python_svg__a)",
    fillRule: "evenodd",
    d: "M21.27 7.5c-2.746 0-4.972 2.156-4.972 4.815v3.333h8.606v.926H12.473c-2.747 0-4.973 2.156-4.973 4.815v7.222c0 2.66 2.226 4.815 4.973 4.815h2.868v-4.074c0-2.66 2.227-4.815 4.973-4.815h9.18c2.324 0 4.208-1.824 4.208-4.074v-8.148c0-2.66-2.226-4.815-4.972-4.815zm-1.147 5.926c.95 0 1.721-.746 1.721-1.667 0-.92-.77-1.666-1.721-1.666-.95 0-1.721.746-1.721 1.666s.77 1.667 1.721 1.667",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#python_svg__b)",
    fillRule: "evenodd",
    d: "M28.73 42.5c2.746 0 4.972-2.156 4.972-4.815v-3.333h-8.606v-.926h12.431c2.747 0 4.973-2.156 4.973-4.815V21.39c0-2.66-2.226-4.815-4.973-4.815h-2.869v4.074c0 2.66-2.226 4.815-4.972 4.815h-9.18c-2.324 0-4.208 1.824-4.208 4.074v8.148c0 2.66 2.226 4.815 4.973 4.815zm1.147-5.926c-.95 0-1.721.746-1.721 1.667 0 .92.77 1.666 1.721 1.666.95 0 1.721-.746 1.721-1.666s-.77-1.667-1.72-1.667",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "python_svg__a",
    x1: 20.601,
    x2: 20.601,
    y1: 7.5,
    y2: 33.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1565A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "python_svg__b",
    x1: 29.399,
    x2: 29.399,
    y1: 16.574,
    y2: 42.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C600"
  })))));
};
export default SvgPython;